/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownVisaStatus } from '../models/db_DropdownVisaStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class VisaStatuses {
    /**
     * Get a list of visa statuses
     * @returns db_DropdownVisaStatus OK
     * @throws ApiError
     */
    public static listVisaStatuses(): CancelablePromise<Array<db_DropdownVisaStatus>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/visa-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
